import ActionTypes from "../../../../../constants/ActionTypes";
import { ICheckoutData, IOrder } from "../../../../../entities/manhattan/order/types";
import {
  IGetOrderFromCookieAction,
  IRequestFetchOrderAction,
  ISetManhattanOrderAction,
  ISetManhattanCheckoutDataAction,
  ISubmitDataForNextStepAction,
  IGoToNextStepAction,
  IGoToPreviousStepAction,
  ISubmitDataForPreviousStepAction,
  ISetManhattanOreAction, ISetManhattanOrderCanContinue,
} from "./types";

export function requestFetchManhattanOrderAction(params: object): IRequestFetchOrderAction {
  return {
    type: ActionTypes.ORDER.MANHATTAN.FETCH_ORDER,
    params,
  };
}

export function setManhattanOrderAction(order: IOrder): ISetManhattanOrderAction {
  return {
    type: ActionTypes.ORDER.MANHATTAN.SET_ORDER,
    payload: order,
  };
}

export function setManhattanCheckoutDataAction(checkoutData: ICheckoutData): ISetManhattanCheckoutDataAction {
  return {
    type: ActionTypes.ORDER.MANHATTAN.SET_CHECKOUT_DATA,
    payload: checkoutData,
  };
}

export function setManhattanCustomerInputDataAction(customerInputData: any): any {
  return {
    type: ActionTypes.ORDER.MANHATTAN.SET_CUSTOMER_INPUT_DATA,
    payload: customerInputData,
  };
}

export function manhattanOrderValidatorAction(order: IOrder) {
  return {
    type: ActionTypes.ORDER.MANHATTAN.ORDER_VALIDATOR,
    payload: order
  };
}

export function getOrderFromCookieAction(): IGetOrderFromCookieAction {
  return {
    type: ActionTypes.ORDER.MANHATTAN.GET_ORDER,
  };
}

export const goToNextStepAction = (data: any): IGoToNextStepAction => (
  {
    type: ActionTypes.ORDER.MANHATTAN.GO_TO_NEXT_STEP,
    payload: data
  }
);

export const goToPreviousStepAction = (stepName: string): IGoToPreviousStepAction => (
  {
    type: ActionTypes.ORDER.MANHATTAN.GO_TO_PREVIOUS_STEP,
    payload: {
      stepName
    }
  }
);

export function submitDataForNextStepAction(data: any): ISubmitDataForNextStepAction {
  return {
    type: ActionTypes.ORDER.MANHATTAN.SUBMIT_ORDER_DATA_STEP,
    payload: {
      data
    },
  };
}

export function submitDataForPreviousStepAction(data: any): ISubmitDataForPreviousStepAction {
  return {
    type: ActionTypes.ORDER.MANHATTAN.SUBMIT_ORDER_PREVIOUS_DATA_STEP,
    payload: {
      data
    },
  };
}

export function setManhattanOreAction(data: { offerId: number; optionId: number; }): ISetManhattanOreAction {
  return {
    type: ActionTypes.ORDER.MANHATTAN.SET_ORE,
    payload: data
  };
}

export function setManhattanOrderCanContinue(canContinue: boolean): ISetManhattanOrderCanContinue {
  return {
    type: ActionTypes.ORDER.MANHATTAN.CAN_CONTINUE,
    payload: canContinue
  };
}
